<template>
  <div class="root">
    <div style="margin-top: 15px; margin-left: 75px">
      <div style="display: inline-block; float: left">
        <img src="@/assets/images/avatar.jpeg" width="40px" style="border-radius: 50%" />
      </div>
      <div style="
              display: inline-block;
              margin-left: 12px;
              margin-top: -2px;
              color: aliceblue;
            ">
        <span style="font-size: 1.4rem; color: cyan">{{
          getLoginUsername()
        }}</span>
        <div style="font-size: 0.5rem; margin-top: 2px">
          <span class="text-link" @click="onClickChangePasswordBtn">修改密码</span>
          <span class="text-link" @click="onClickLogoutBtn" style="margin-left: 8px">退出登录</span>
        </div>
      </div>
    </div>
    <div style="
            height: 1px;
            width: 330px;
            background-color: white;
            margin-top: 15px;
            margin-bottom: 15px;
          "></div>
    <div style="text-align: center; color: aliceblue; font-size: 2rem">
      <span>管理后台</span>
    </div>
    <el-menu :default-active="$route.path" router background-color="#545c64" text-color="#fff"
      active-text-color="#ffd04b">
      <el-menu-item index="/console/system-config">
        <i class="el-icon-setting"></i>
        <span slot="title">系统设置</span>
      </el-menu-item>
      <el-menu-item index="/announcement/edit">
        <i class="iconfont icon-gonggao1"></i>
        <span slot="title">公告</span>
      </el-menu-item>
      <el-menu-item index="/console/misc/qqgroups">
        <i class="el-icon-chat-dot-square"></i>
        <span slot="title">QQ群</span>
      </el-menu-item>
      <el-menu-item index="/mail/templateList">
        <i class="el-icon-message"></i>
        <span slot="title">邮件</span>
      </el-menu-item>
      <!--
      <el-menu-item index="/speaker">
        <i class="iconfont icon-laba"></i>
        <span slot="title">喇叭</span>
      </el-menu-item>
      -->
      <el-menu-item index="/zone/list">
        <i class="el-icon-s-grid"></i>
        <span slot="title">分区</span>
      </el-menu-item>
      <el-menu-item index="/adminUser/list">
        <i class="el-icon-s-grid"></i>
        <span slot="title">账号</span>
      </el-menu-item>
      <el-menu-item index="/function-switch/list">
        <i class="el-icon-switch-button"></i>
        <span slot="title">功能开关</span>
      </el-menu-item>
      <el-menu-item index="/console/version">
        <i class="el-icon-s-flag"></i>
        <span slot="title">版本管理</span>
      </el-menu-item>
    </el-menu>

    <!-- “修改密码”对话框 -->
    <ChangeAdminUserPasswordDialog v-if="shouldChangeAdminUserPasswordDialogVisible"
      @close="shouldChangeAdminUserPasswordDialogVisible = false"></ChangeAdminUserPasswordDialog>
  </div>
</template>

<script>
import util from "@/util";
import ChangeAdminUserPasswordDialog from "@/pages/adminUser/ChangeAdminUserPasswordDialog";

export default {
  data() {
    return {
      shouldChangeAdminUserPasswordDialogVisible: false, // “修改密码”对话框是否应该显示出来
    };
  },

  components: {
    ChangeAdminUserPasswordDialog,
  },

  methods: {
    /**
     * 点击了“修改密码”按钮
     */
    onClickChangePasswordBtn() {
      this.shouldChangeAdminUserPasswordDialogVisible = true;
    },

    /**
     * 点击了“退出登录”按钮
     */
    onClickLogoutBtn() {
      util.removeFromLocalStorage("loginUser");
      util.gotoLoginPage();
    },

    /**
     * 取得当前登录用户的用户名
     */
    getLoginUsername() {
      let loginUser = util.getFromLocalStorage("loginUser");
      if (loginUser) {
        return loginUser.username;
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.root {
  height: 100vh;
  background-color: #545c64;
}

.el-menu {
  border-right: 0px;
}

.el-submenu,
.el-menu-item {
  text-align: left;
}

.el-submenu .el-menu-item {
  margin-left: 20px;
}

.text-link {
  text-decoration: underline;
  cursor: pointer;
  color: dodgerblue;
}
</style>